import assignToThis from '../../helper/assignToThis';
import { ObjectOnly } from '@/classes/ObjectOnly';

export class PVCurve {

  public values: number[] | null = null;

  public durationYear: number | null = null;

  public startDate: Date | null = null;

  public stepMinutes: number | null = null;

  public constructor(obj: ObjectOnly = {}) {
    assignToThis(this, obj);
  }

}
